export const inputType = {
  Text: "text",
  TextArea: "textarea",
  Email: "email",
  Phone: "tel",
  Password: "password",
  Number: "number",
};

export const inputSize = {
  Size_100: "100%",
  Size_66: "66%",
  Size_50: "50%",
  Size_33: "33%",
};
